var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("This page has expired!")]),_c('p',[_vm._v("The page you are looking for may have been moved, deleted, or possibly never existed.")])])
}]

export { render, staticRenderFns }